import axios from '@/CommonDP/utils/request';
export function pageList(data) {
  return axios({
    url: '/light-weight/manage/pageList',
    method: 'post',
    data
  });
}
export function lightDicList() {
  return axios(
    '/light-weight/manage/light-status/DicList');
}
export function lightFormatsDicList() {
  return axios(
    '/light-weight/manage/light-file-formats/DicList');
}
export function batchLightWeight(data) {
  return axios({
    url: '/light-weight/manage/batchLightWeight',
    method: 'post',
    data
  });
}
